// MAIN FRIDGE OBJECTS — achaar, dabbas, chaos. All cartoon SVGs, swappable later.
// Art language: plates/bowls, glossy highlights, soft shading — Tom & Jerry fridge energy.
const INK = "#2B2320";
const S = { stroke: INK, strokeWidth: 4, strokeLinejoin: "round", strokeLinecap: "round" };
const Hand = { fontFamily: "'Kalam',cursive", fontWeight: 700 };

export const AchaarJar = () => (
  <svg viewBox="0 0 100 100" className="w-full h-full overflow-visible">
    <g {...S}>
      <path d="M24 30 h52 v44 a12 12 0 0 1 -12 12 h-28 a12 12 0 0 1 -12 -12 z" fill="#DCE9F2" />
      <path d="M28 44 h44 v30 a8 8 0 0 1 -8 8 h-28 a8 8 0 0 1 -8 -8 z" fill="#E8760C" strokeWidth="3" />
      <path d="M28 44 h44 v7 h-44 z" fill="#C2410C" strokeWidth="2.5" />
      <path d="M34 60 q7 -5 12 2 q-5 7 -12 -2" fill="#F3D98B" strokeWidth="2.5" />
      <path d="M54 70 q7 -5 12 2 q-5 7 -12 -2" fill="#F3D98B" strokeWidth="2.5" />
      <path d="M58 52 q8 -2 10 4 q-6 4 -10 -4" fill="#C2410C" strokeWidth="2.5" />
      <circle cx="40" cy="74" r="2.6" fill="#C2410C" strokeWidth="2" />
      <circle cx="64" cy="76" r="1.7" fill="#FFF3D6" strokeWidth="1.4" />
      <circle cx="36" cy="68" r="1.7" fill="#FFF3D6" strokeWidth="1.4" />
      <circle cx="48" cy="56" r="1.7" fill="#FFF3D6" strokeWidth="1.4" />
      <ellipse cx="50" cy="28" rx="28" ry="9" fill="#F6EFE7" />
      <path d="M24 30 q-3 8 3 12 M76 30 q3 8 -3 12" fill="none" strokeWidth="3" />
      <path d="M26 36 h48" stroke="#C9A227" strokeWidth="2.5" fill="none" />
      <ellipse cx="50" cy="25" rx="24" ry="6.5" fill="#EAE2D6" />
      <ellipse cx="50" cy="24" rx="24" ry="4.5" fill="#F6EFE7" strokeWidth="2.5" />
      <path d="M30 32 v40" stroke="#F4FAFD" strokeWidth="5" fill="none" opacity="0.85" />
    </g>
    <g>
      <rect x="31" y="48" width="38" height="15" rx="3" fill="#FFFCF2" stroke={INK} strokeWidth="2.5" transform="rotate(-3 50 55)" />
    </g>
  </svg>
);

export const SteelDabba = () => (
  <svg viewBox="0 0 100 100" className="w-full h-full overflow-visible">
    <g {...S}>
      <path d="M20 28 v44 a30 11 0 0 0 60 0 v-44" fill="#C9CDD3" />
      <path d="M20 28 v44 a30 11 0 0 0 30 11 v-44 z" fill="#AEB4BC" strokeWidth="3" />
      <path d="M80 28 v44 a30 11 0 0 1 -10 9 v-46 z" fill="#D9DDE2" strokeWidth="2.5" />
      <ellipse cx="50" cy="72" rx="30" ry="11" fill="#9AA1AB" strokeWidth="3.5" />
      <path d="M22 42 h56 M22 56 h56" stroke="#9AA1AB" strokeWidth="2" fill="none" opacity="0.7" />
      <ellipse cx="50" cy="28" rx="30" ry="9.5" fill="#D7DBE0" />
      <path d="M22 27 q10 -6 22 -6" stroke="#F3F5F7" strokeWidth="3.5" fill="none" opacity="0.9" />
      <ellipse cx="50" cy="21" rx="30" ry="9.5" fill="#E3E7EB" />
      <ellipse cx="50" cy="19.5" rx="22" ry="6" fill="#EEF1F4" strokeWidth="3" />
      <circle cx="50" cy="13" r="5" fill="#B8B2A8" />
      <circle cx="48.5" cy="11.5" r="1.6" fill="#EAE2D6" strokeWidth="1.5" />
      <path d="M30 36 v30" stroke="#F3F5F7" strokeWidth="5" opacity="0.95" fill="none" />
      <path d="M68 36 v24" stroke="#F3F5F7" strokeWidth="2.5" opacity="0.6" fill="none" />
    </g>
  </svg>
);

export const TiffinBox = () => (
  <svg viewBox="0 0 100 100" className="w-full h-full overflow-visible">
    <g {...S}>
      <path d="M32 14 a18 14 0 0 1 36 0" fill="none" />
      <rect x="30" y="18" width="40" height="14" rx="4" fill="#D7DBE0" />
      <rect x="26" y="38" width="48" height="16" rx="4" fill="#C9CDD3" />
      <path d="M24 60 h52 v12 a6 6 0 0 1 -6 6 h-40 a6 6 0 0 1 -6 -6 z" fill="#B7BBC1" />
      <path d="M36 22 v4 M64 22 v4 M36 42 v4 M64 42 v4" strokeWidth="3" fill="none" />
      <path d="M32 46 h12" stroke="#F3F5F7" strokeWidth="4" opacity="0.9" fill="none" />
    </g>
  </svg>
);

export const Sandwich = () => (
  <svg viewBox="0 0 100 100" className="w-full h-full overflow-visible">
    <g {...S}>
      <ellipse cx="50" cy="88" rx="46" ry="10" fill="#F6F9FC" />
      <ellipse cx="50" cy="87" rx="36" ry="7" fill="#E4ECF2" strokeWidth="2.5" />
      <path d="M12 74 l-8 -16 M18 76 l-4 -18" stroke="#FFD166" strokeWidth="6" fill="none" />
      <path d="M14 66 l-6 -12 M18 72 l-2 -14" stroke="#E8B33C" strokeWidth="2" fill="none" />
      <path d="M22 38 q28 -14 56 0 l-5 7 q-23 -9 -46 0 z" fill="#F3D98B" />
      <path d="M25 45 q25 -7 50 0 l-4 6 q-21 -6 -42 0 z" fill="#7FBF4D" />
      <path d="M26 51 q24 -5 48 0 l-4 6 q-20 -4 -40 0 z" fill="#FF6B6B" />
      <path d="M27 57 q23 -4 46 0 l-4 6 q-19 -3 -38 0 z" fill="#FFF3D6" />
      <path d="M28 63 q22 -3 44 0 l-4 6 q-18 -3 -36 0 z" fill="#8B5A2B" />
      <path d="M29 69 q21 -3 42 0 l-4 6 q-17 -3 -34 0 z" fill="#7FBF4D" />
      <path d="M30 75 q20 -3 40 0 l-7 9 q-13 -3 -26 0 z" fill="#E8B968" />
      <path d="M34 46 q6 3 10 -1 q4 4 10 1 q4 -3 8 1" stroke="#FF5964" strokeWidth="2" fill="none" opacity="0.9" />
      <path d="M50 32 v-14" strokeWidth="2.5" fill="none" />
      <ellipse cx="50" cy="16" rx="5" ry="4" fill="#7FBF4D" />
      <circle cx="50" cy="16" r="1.6" fill="#E8563F" strokeWidth="1.5" />
      <ellipse cx="38" cy="35" rx="1.6" ry="1" fill="#FFF" strokeWidth="1" />
      <ellipse cx="50" cy="32" rx="1.6" ry="1" fill="#FFF" strokeWidth="1" />
      <ellipse cx="62" cy="35" rx="1.6" ry="1" fill="#FFF" strokeWidth="1" />
    </g>
  </svg>
);

export const CheeseWheel = () => (
  <svg viewBox="0 0 100 100" className="w-full h-full overflow-visible">
    <g {...S}>
      <ellipse cx="50" cy="86" rx="42" ry="9" fill="#E8B968" />
      <ellipse cx="50" cy="85" rx="33" ry="6.5" fill="#F3D98B" strokeWidth="2.5" />
      <path d="M22 40 v34 a28 12 0 0 0 56 0 v-34" fill="#F0B93C" />
      <path d="M22 40 v34 a28 12 0 0 0 20 11 v-40 z" fill="#D9A02E" strokeWidth="2.5" />
      <ellipse cx="50" cy="40" rx="28" ry="12" fill="#FFD166" />
      <ellipse cx="40" cy="38" rx="4" ry="2.5" fill="#D9A02E" strokeWidth="2" />
      <ellipse cx="56" cy="43" rx="3" ry="2" fill="#D9A02E" strokeWidth="2" />
      <ellipse cx="52" cy="34" rx="2.4" ry="1.6" fill="#D9A02E" strokeWidth="1.6" />
      <ellipse cx="36" cy="56" rx="3.4" ry="2.4" fill="#C98F26" strokeWidth="2" />
      <ellipse cx="58" cy="64" rx="3" ry="2.2" fill="#C98F26" strokeWidth="2" />
      <ellipse cx="66" cy="50" rx="2.6" ry="2" fill="#C98F26" strokeWidth="1.8" />
      <path d="M28 34 q8 -6 18 -6" stroke="#FFE9A8" strokeWidth="3.5" fill="none" />
      <path d="M74 74 l16 -10 v12 l-16 8 z" fill="#FFD166" strokeWidth="2.5" />
      <path d="M74 74 l16 -10" strokeWidth="2.5" fill="none" />
    </g>
  </svg>
);

export const RoastChicken = () => (
  <svg viewBox="0 0 100 100" className="w-full h-full overflow-visible">
    <g {...S}>
      <ellipse cx="50" cy="84" rx="44" ry="10" fill="#F6F9FC" />
      <ellipse cx="50" cy="83" rx="34" ry="7" fill="#E4ECF2" strokeWidth="2.5" />
      <path d="M16 78 q6 -8 14 -4 M70 80 q8 -8 16 -2" stroke="#7FBF4D" strokeWidth="4" fill="none" />
      <ellipse cx="48" cy="60" rx="28" ry="22" fill="#C97B3D" />
      <path d="M26 52 q10 -14 28 -12 q10 2 16 10" stroke="#E8A05C" strokeWidth="7" fill="none" opacity="0.9" />
      <path d="M32 66 q6 4 12 2 M50 72 q6 2 12 -2 M60 58 q5 3 10 1" stroke="#8B4A1F" strokeWidth="2" fill="none" opacity="0.7" />
      <path d="M70 44 q12 -10 18 -14" stroke="#C97B3D" strokeWidth="11" fill="none" />
      <circle cx="90" cy="28" r="7" fill="#E8A05C" />
      <path d="M88 24 q3 3 2 6" stroke="#8B4A1F" strokeWidth="2" fill="none" />
      <path d="M94 22 q4 -4 7 -1 q1 4 -3 5 z" fill="#FFFDF4" strokeWidth="2.5" />
      <path d="M26 58 q-6 8 -2 14 q8 2 12 -6" fill="#B96A30" strokeWidth="2.5" />
      <circle cx="40" cy="50" r="1.8" fill="#FFF3D6" strokeWidth="1.2" />
      <circle cx="56" cy="56" r="1.8" fill="#FFF3D6" strokeWidth="1.2" />
      <path d="M38 30 q3 -5 0 -9 M50 28 q3 -5 0 -9" stroke="#C9CDD3" strokeWidth="2.5" fill="none" opacity="0.8" />
    </g>
  </svg>
);

export const LayerDessert = () => (
  <svg viewBox="0 0 100 100" className="w-full h-full overflow-visible">
    <g {...S}>
      <path d="M44 70 h12 l3 14 h-18 z" fill="#DFF3FF" />
      <ellipse cx="50" cy="86" rx="16" ry="4.5" fill="#DFF3FF" />
      <path d="M30 28 h40 l-4 40 a8 8 0 0 1 -8 8 h-16 a8 8 0 0 1 -8 -8 z" fill="#EAF6FF" />
      <path d="M32 36 h36 l-1 8 h-34 z" fill="#FF5964" strokeWidth="2.5" />
      <path d="M33 44 h34 l-1 7 h-32 z" fill="#FFF3D6" strokeWidth="2.5" />
      <path d="M34 51 h32 l-1 7 h-30 z" fill="#FF5964" strokeWidth="2.5" />
      <path d="M35 58 h30 l-1.5 8 h-27 z" fill="#8B5A2B" strokeWidth="2.5" />
      <path d="M36 66 h28 l-1 5 h-26 z" fill="#FFD166" strokeWidth="2.5" />
      <path d="M34 28 q2 -10 10 -8 q0 -8 8 -8 q8 0 8 8 q8 -2 8 8 z" fill="#FFFDF4" />
      <circle cx="42" cy="20" r="3" fill="#FFFDF4" strokeWidth="2.5" />
      <circle cx="58" cy="20" r="3" fill="#FFFDF4" strokeWidth="2.5" />
      <circle cx="50" cy="12" r="5.5" fill="#FF5964" />
      <circle cx="48" cy="10" r="1.5" fill="#fff" strokeWidth="1" />
      <path d="M50 7 q4 -5 11 -5" fill="none" strokeWidth="2.5" />
      <path d="M64 22 l9 -14" stroke="#E8B968" strokeWidth="5" fill="none" />
      <path d="M66 18 l3 -4 M68 21 l3 -4" stroke="#8B5A2B" strokeWidth="1.4" fill="none" />
      <path d="M40 24 l2 2 M54 26 l2 -2 M60 22 l2 2" stroke="#35A7FF" strokeWidth="2" fill="none" />
      <path d="M46 27 l2 2" stroke="#FF8FB1" strokeWidth="2" fill="none" />
      <path d="M34 32 v30" stroke="#fff" strokeWidth="3" fill="none" opacity="0.8" />
    </g>
  </svg>
);

export const MilkPacket = () => (
  <svg viewBox="0 0 100 100" className="w-full h-full overflow-visible">
    <g {...S}>
      <path d="M32 12 h36 l7 10 v40 q10 14 0 20 q-6 4 -14 4 h-22 q-8 0 -14 -4 q-10 -6 0 -20 v-40 z" fill="#F6F9FC" />
      <path d="M32 12 l7 10 h22 l7 -10" fill="#DCE9F2" strokeWidth="3" />
      <path d="M36 15 l3 -3 M48 15 l3 -3 M60 15 l3 -3" strokeWidth="2" fill="none" />
      <ellipse cx="50" cy="42" rx="11" ry="9" fill="#fff" strokeWidth="3" />
      <path d="M41 38 q-4 -6 -8 -5 M59 38 q4 -6 8 -5" fill="none" strokeWidth="2.5" />
      <path d="M46 33 l-2 -4 M54 33 l2 -4" fill="none" strokeWidth="2.5" />
      <circle cx="46" cy="41" r="1.2" fill={INK} strokeWidth="1" />
      <circle cx="54" cy="41" r="1.2" fill={INK} strokeWidth="1" />
      <ellipse cx="50" cy="48" rx="5" ry="3" fill="#F4C7C3" strokeWidth="2" />
      <path d="M28 62 q22 10 44 0 v16 q-6 6 -14 6 h-16 q-8 0 -14 -6 z" fill="#DCE9F2" strokeWidth="3" />
      <path d="M32 66 q10 6 20 2" stroke="#fff" strokeWidth="3" fill="none" opacity="0.85" />
    </g>
  </svg>
);

export const CurdContainer = () => (
  <svg viewBox="0 0 100 100" className="w-full h-full overflow-visible">
    <g {...S}>
      <path d="M26 46 h48 l-4 30 a9 9 0 0 1 -9 9 h-22 a9 9 0 0 1 -9 -9 z" fill="#FFF7E6" />
      <ellipse cx="50" cy="46" rx="24" ry="7.5" fill="#FFFDF4" />
      <path d="M36 44 q8 -5 16 -2" stroke="#F3E6C8" strokeWidth="4" fill="none" />
      <path d="M42 47 q6 2 12 0" stroke="#F3E6C8" strokeWidth="3" fill="none" />
      <path d="M28 44 q-4 -8 6 -12 l4 8 q-8 2 -10 4 z" fill="#C9CDD3" strokeWidth="2.5" />
      <ellipse cx="50" cy="42" rx="24" ry="6" fill="none" strokeWidth="3" />
      <path d="M60 24 l9 -9" stroke="#9AA1AB" strokeWidth="4" fill="none" />
      <ellipse cx="58" cy="26" rx="6" ry="4" fill="#C9CDD3" strokeWidth="2.5" transform="rotate(35 58 26)" />
      <path d="M70 60 q3 6 0 9 q-4 -2 -2 -8" fill="#FFF7E6" strokeWidth="2" />
    </g>
  </svg>
);

export const CorianderBowl = () => (
  <svg viewBox="0 0 100 100" className="w-full h-full overflow-visible">
    <g {...S}>
      <path d="M38 48 q-2 -14 4 -20 M50 46 q0 -12 4 -18 M62 48 q4 -10 10 -14" fill="none" stroke="#4F9D4F" strokeWidth="4" />
      <path d="M32 34 q8 -6 12 2 M46 30 q8 -2 10 8 M58 32 q8 0 12 8" fill="none" stroke="#4F9D4F" strokeWidth="3.5" />
      <circle cx="42" cy="30" r="3" fill="#7FBF4D" strokeWidth="2.5" />
      <circle cx="56" cy="26" r="3" fill="#7FBF4D" strokeWidth="2.5" />
      <path d="M20 52 h60 a30 24 0 0 1 -60 0 z" fill="#C9CDD3" />
      <ellipse cx="50" cy="52" rx="30" ry="7" fill="#D7DBE0" />
    </g>
  </svg>
);

export const PaneerCube = () => (
  <svg viewBox="0 0 100 100" className="w-full h-full overflow-visible">
    <g {...S}>
      <path d="M26 40 l24 -12 24 12 v28 l-24 12 -24 -12 z" fill="#FFFDF4" />
      <path d="M26 40 l24 12 24 -12 M50 52 v28" fill="none" strokeWidth="3.5" />
      <path d="M32 44 l12 -6" stroke="#FFF3D6" strokeWidth="4" fill="none" />
    </g>
  </svg>
);

export const LeftoverContainer = () => (
  <svg viewBox="0 0 100 100" className="w-full h-full overflow-visible">
    <g {...S}>
      <rect x="18" y="42" width="64" height="30" rx="6" fill="#C9CDD3" />
      <rect x="22" y="30" width="56" height="14" rx="6" fill="#D7DBE0" />
      <path d="M40 37 h20" strokeWidth="3" fill="none" />
      <circle cx="28" cy="49" r="2.5" fill="#8A9099" strokeWidth="2" />
      <circle cx="72" cy="49" r="2.5" fill="#8A9099" strokeWidth="2" />
    </g>
  </svg>
);

export const PeanutButterJar = () => (
  <svg viewBox="0 0 100 100" className="w-full h-full overflow-visible">
    <g {...S}>
      <path d="M30 30 h40 v44 a10 10 0 0 1 -10 10 h-20 a10 10 0 0 1 -10 -10 z" fill="#D9A066" />
      <rect x="30" y="44" width="40" height="18" fill="#FFF3D6" strokeWidth="3" />
      <rect x="32" y="14" width="36" height="16" rx="5" fill="#E8760C" />
    </g>
    <ellipse cx="38" cy="38" rx="4" ry="2.5" fill="#fff" opacity="0.7" stroke="none" />
  </svg>
);

export const WaterBottle = () => (
  <svg viewBox="0 0 100 100" className="w-full h-full overflow-visible">
    <g {...S}>
      <rect x="40" y="10" width="20" height="10" rx="3" fill="#8FD0EE" />
      <path d="M42 20 h16 v10 q8 6 8 18 v28 a8 8 0 0 1 -8 8 h-16 a8 8 0 0 1 -8 -8 v-28 q0 -12 8 -18 z" fill="#DFF3FF" />
      <path d="M36 56 h28 v14 a6 6 0 0 1 -6 6 h-16 a6 6 0 0 1 -6 -6 z" fill="#8FD0EE" strokeWidth="3.5" />
    </g>
  </svg>
);

export const SauceBottle = () => (
  <svg viewBox="0 0 100 100" className="w-full h-full overflow-visible">
    <g {...S}>
      <rect x="44" y="8" width="12" height="10" rx="3" fill="#C2410C" />
      <path d="M44 18 h12 v8 q12 8 12 22 v24 a12 12 0 0 1 -12 12 h-12 a12 12 0 0 1 -12 -12 v-24 q0 -14 12 -22 z" fill="#FF6B6B" />
      <rect x="34" y="52" width="32" height="16" fill="#FFF3D6" strokeWidth="3" />
    </g>
  </svg>
);

export const ChocolateCake = () => (
  <svg viewBox="0 0 100 100" className="w-full h-full overflow-visible">
    <g {...S}>
      <ellipse cx="50" cy="86" rx="44" ry="10" fill="#F6F9FC" />
      <ellipse cx="50" cy="85" rx="34" ry="7" fill="#E4ECF2" strokeWidth="2.5" />
      <path d="M24 46 h52 v26 a26 10 0 0 1 -52 0 z" fill="#7A4A21" />
      <path d="M24 46 v26 a26 10 0 0 0 17 9 v-35 z" fill="#5E3617" strokeWidth="2.5" />
      <path d="M24 62 a26 10 0 0 0 52 0" stroke="#F3D98B" strokeWidth="5" fill="none" />
      <path d="M22 46 q0 -6 8 -6 h40 q8 0 8 6 q0 5 -5 5 q-2 8 -7 8 q-5 0 -5 -6 q-2 10 -8 10 q-6 0 -6 -9 q-3 7 -8 7 q-5 0 -6 -8 q-3 5 -6 3 q-5 -3 -5 -10 z" fill="#3A1A08" />
      <path d="M30 43 q6 -3 12 -1" stroke="#8A5A33" strokeWidth="3" fill="none" opacity="0.9" />
      <path d="M50 36 q2 -8 8 -10" stroke="#4F9D4F" strokeWidth="2.5" fill="none" />
      <circle cx="50" cy="35" r="6.5" fill="#E8563F" />
      <circle cx="48" cy="33" r="2" fill="#FF9D8A" strokeWidth="1.5" />
    </g>
  </svg>
);

export const CandyJar = () => (
  <svg viewBox="0 0 100 100" className="w-full h-full overflow-visible">
    <g {...S}>
      <path d="M26 34 h48 v38 a14 14 0 0 1 -14 14 h-20 a14 14 0 0 1 -14 -14 z" fill="#DCE9F2" />
      <circle cx="38" cy="72" r="7" fill="#FF5964" strokeWidth="2.5" />
      <circle cx="54" cy="76" r="7" fill="#FFE66D" strokeWidth="2.5" />
      <circle cx="66" cy="68" r="6" fill="#38BDF8" strokeWidth="2.5" />
      <circle cx="46" cy="62" r="6" fill="#38B000" strokeWidth="2.5" />
      <circle cx="62" cy="56" r="5.5" fill="#F472B6" strokeWidth="2.5" />
      <circle cx="36" cy="56" r="5" fill="#E8760C" strokeWidth="2.5" />
      <circle cx="36" cy="70" r="1.6" fill="#FFF" stroke="none" />
      <circle cx="52" cy="74" r="1.6" fill="#FFF" stroke="none" />
      <circle cx="64" cy="66" r="1.4" fill="#FFF" stroke="none" />
      <ellipse cx="50" cy="32" rx="26" ry="8" fill="#E8563F" />
      <ellipse cx="50" cy="27" rx="20" ry="6" fill="#FF6B6B" />
      <circle cx="50" cy="19" r="5" fill="#E8563F" />
      <circle cx="48.5" cy="17.5" r="1.6" fill="#FF9D8A" strokeWidth="1.4" />
      <path d="M32 42 v34" stroke="#F4FAFD" strokeWidth="5" fill="none" opacity="0.85" />
    </g>
  </svg>
);

export const SodaCan = () => (
  <svg viewBox="0 0 100 100" className="w-full h-full overflow-visible">
    <g {...S}>
      <path d="M32 24 v50 a18 8 0 0 0 36 0 v-50" fill="#DC2626" />
      <path d="M32 24 v50 a18 8 0 0 0 12 6 v-52 z" fill="#B91C1C" strokeWidth="2.5" />
      <ellipse cx="50" cy="74" rx="18" ry="7" fill="#B91C1C" strokeWidth="3" />
      <ellipse cx="50" cy="24" rx="18" ry="7" fill="#D7DBE0" />
      <ellipse cx="50" cy="23" rx="12" ry="4.5" fill="#E9EDF1" strokeWidth="2.5" />
      <circle cx="50" cy="23" r="2.4" fill="#9AA1AB" strokeWidth="2" />
      <path d="M32 44 a18 7 0 0 0 36 0 v10 a18 7 0 0 1 -36 0 z" fill="#FFF3D6" strokeWidth="3" />
      <circle cx="42" cy="36" r="1.6" fill="#FFE66D" strokeWidth="1.2" />
      <circle cx="58" cy="62" r="1.6" fill="#FFE66D" strokeWidth="1.2" />
      <path d="M38 30 v36" stroke="#FF8A80" strokeWidth="4" fill="none" opacity="0.8" />
    </g>
  </svg>
);

export const SodaBottle = () => (
  <svg viewBox="0 0 100 100" className="w-full h-full overflow-visible">
    <g {...S}>
      <rect x="43" y="8" width="14" height="8" rx="2.5" fill="#C2410C" />
      <path d="M44 16 h12 v10 q14 10 14 26 v22 a10 10 0 0 1 -10 10 h-20 a10 10 0 0 1 -10 -10 v-22 q0 -16 14 -26 z" fill="#F59E0B" />
      <path d="M44 16 h6 v10 q-12 10 -12 26 v22 a10 10 0 0 0 6 9 h-4 a10 10 0 0 1 -10 -10 v-22 q0 -16 14 -26 z" fill="#D97706" strokeWidth="2.5" />
      <rect x="32" y="48" width="36" height="18" rx="3" fill="#FFF3D6" strokeWidth="3" />
      <circle cx="44" cy="38" r="1.8" fill="#FFE66D" strokeWidth="1.2" />
      <circle cx="56" cy="42" r="1.5" fill="#FFE66D" strokeWidth="1.2" />
      <path d="M38 30 q-3 12 -3 22" stroke="#FFD98A" strokeWidth="4" fill="none" opacity="0.9" />
    </g>
  </svg>
);

export const JuiceCarton = () => (
  <svg viewBox="0 0 100 100" className="w-full h-full overflow-visible">
    <g {...S}>
      <path d="M32 34 h36 v44 a6 6 0 0 1 -6 6 h-24 a6 6 0 0 1 -6 -6 z" fill="#FDBA3B" />
      <path d="M32 34 l6 -12 h24 l6 12 z" fill="#FFF3D6" />
      <path d="M38 22 h24" strokeWidth="3" fill="none" />
      <path d="M58 22 l8 -12" stroke="#E8563F" strokeWidth="4" fill="none" />
      <circle cx="50" cy="56" r="12" fill="#FF8C42" strokeWidth="3" />
      <path d="M50 44 q2 -4 6 -4" stroke="#4F9D4F" strokeWidth="2.5" fill="none" />
      <circle cx="46" cy="53" r="1.6" fill="#FFD166" strokeWidth="1" />
      <circle cx="54" cy="58" r="1.6" fill="#FFD166" strokeWidth="1" />
      <path d="M36 40 v36" stroke="#FFE1A1" strokeWidth="4" fill="none" opacity="0.9" />
    </g>
  </svg>
);

export const MilkCarton = () => (
  <svg viewBox="0 0 100 100" className="w-full h-full overflow-visible">
    <g {...S}>
      <path d="M32 36 h36 v42 a6 6 0 0 1 -6 6 h-24 a6 6 0 0 1 -6 -6 z" fill="#FDFBF6" />
      <path d="M32 36 l8 -14 h20 l8 14 z" fill="#2563EB" />
      <path d="M40 22 h20" strokeWidth="3" fill="none" />
      <path d="M32 36 h36 v12 h-36 z" fill="#2563EB" strokeWidth="3" />
      <path d="M50 56 q-7 9 -7 13 a7 7 0 0 0 14 0 q0 -4 -7 -13 z" fill="#8FD0EE" strokeWidth="2.5" />
      <path d="M36 50 v28" stroke="#FFF" strokeWidth="4" fill="none" opacity="0.9" />
    </g>
  </svg>
);

export const EggTray = () => (
  <svg viewBox="0 0 100 100" className="w-full h-full overflow-visible">
    <g {...S}>
      <ellipse cx="34" cy="44" rx="9" ry="12" fill="#FFF3D6" />
      <ellipse cx="66" cy="44" rx="9" ry="12" fill="#FDEBD2" />
      <ellipse cx="24" cy="58" rx="9" ry="12" fill="#FDFBF6" />
      <ellipse cx="50" cy="56" rx="9.5" ry="12.5" fill="#FFF3D6" />
      <ellipse cx="76" cy="58" rx="9" ry="12" fill="#FDEBD2" />
      <ellipse cx="21" cy="53" rx="2.5" ry="4" fill="#FFF" stroke="none" opacity="0.9" />
      <ellipse cx="47" cy="51" rx="2.5" ry="4" fill="#FFF" stroke="none" opacity="0.9" />
      <ellipse cx="63" cy="39" rx="2.2" ry="3.4" fill="#FFF" stroke="none" opacity="0.9" />
      <path d="M12 62 h76 v10 a8 6 0 0 1 -8 6 h-60 a8 6 0 0 1 -8 -6 z" fill="#C9B18C" />
      <path d="M12 62 h76" strokeWidth="3" fill="none" />
      <path d="M20 69 h60" stroke="#A98F66" strokeWidth="2.5" fill="none" opacity="0.8" />
    </g>
  </svg>
);

export const ButterTub = () => (
  <svg viewBox="0 0 100 100" className="w-full h-full overflow-visible">
    <g {...S}>
      <path d="M26 40 h48 v26 a24 10 0 0 1 -48 0 z" fill="#FFE66D" />
      <path d="M26 40 v26 a24 10 0 0 0 16 9 v-35 z" fill="#F0C940" strokeWidth="2.5" />
      <ellipse cx="50" cy="40" rx="24" ry="9" fill="#FFF3C4" />
      <ellipse cx="50" cy="34" rx="24" ry="8" fill="#FFE66D" />
      <ellipse cx="50" cy="32" rx="17" ry="5.5" fill="#FFF3C4" strokeWidth="2.5" />
      <path d="M32 48 v14" stroke="#FFF8D6" strokeWidth="4" fill="none" opacity="0.9" />
    </g>
  </svg>
);

export const Pastry = () => (
  <svg viewBox="0 0 100 100" className="w-full h-full overflow-visible">
    <g {...S}>
      <ellipse cx="50" cy="86" rx="36" ry="8" fill="#F6F9FC" />
      <ellipse cx="50" cy="85" rx="28" ry="5.5" fill="#E4ECF2" strokeWidth="2.5" />
      <circle cx="50" cy="58" r="26" fill="#F3D98B" />
      <path d="M50 34 a26 26 0 0 1 24 17 q-4 3 -8 0 q-2 6 -8 5 q-6 1 -8 -4 q-4 5 -10 3 q-6 0 -8 -5 q-4 3 -8 -1 a26 26 0 0 1 26 -15 z" fill="#F472B6" />
      <circle cx="50" cy="58" r="8" fill="#FBF6EA" />
      <path d="M36 44 l4 3 M58 40 l4 2 M64 50 l4 -1 M40 52 l4 -2 M52 46 l3 3" stroke="#FFE66D" strokeWidth="2.5" fill="none" />
      <path d="M44 40 l3 3 M62 44 l3 2" stroke="#38BDF8" strokeWidth="2.5" fill="none" />
      <path d="M34 48 q2 -6 8 -8" stroke="#FBD9E8" strokeWidth="3" fill="none" opacity="0.9" />
    </g>
  </svg>
);

export const WatermelonSlice = () => (
  <svg viewBox="0 0 100 100" className="w-full h-full overflow-visible">
    <g {...S}>
      <path d="M12 38 a40 40 0 0 0 76 0 z" fill="#2F9E44" />
      <path d="M17 38 a35 35 0 0 0 66 0 z" fill="#D8F3DC" strokeWidth="2.5" />
      <path d="M21 38 a31 31 0 0 0 58 0 z" fill="#FF5964" strokeWidth="2.5" />
      <ellipse cx="38" cy="52" rx="2" ry="3" fill="#2B2320" strokeWidth="1.5" />
      <ellipse cx="52" cy="58" rx="2" ry="3" fill="#2B2320" strokeWidth="1.5" />
      <ellipse cx="64" cy="50" rx="2" ry="3" fill="#2B2320" strokeWidth="1.5" />
      <ellipse cx="46" cy="66" rx="2" ry="3" fill="#2B2320" strokeWidth="1.5" />
      <ellipse cx="30" cy="44" rx="1.8" ry="2.6" fill="#2B2320" strokeWidth="1.4" />
      <path d="M27 42 q8 -4 15 -2" stroke="#FF9D8A" strokeWidth="3" fill="none" opacity="0.9" />
    </g>
  </svg>
);

// ---- spills & mess — puddles that drip over the shelf edge ----
export const KetchupSpill = () => (
  <svg viewBox="0 0 100 100" className="w-full h-full overflow-visible">
    <g {...S}>
      <path d="M10 30 q10 -12 24 -6 q16 7 28 0 q14 -7 26 3 q10 8 0 15 q-12 8 -26 3 q-14 8 -28 2 q-18 -4 -24 -17 z" fill="#E8563F" />
      <path d="M30 46 q-2 16 2 27 q2 9 8 6 q5 -3 2 -14 q-1 -10 4 -19" fill="#E8563F" strokeWidth="3" />
      <path d="M64 44 q0 13 4 22 q3 8 8 4 q4 -4 0 -14 q-2 -8 2 -14" fill="#D63F2A" strokeWidth="3" />
      <ellipse cx="34" cy="29" rx="9" ry="3.5" fill="#FF9D8A" stroke="none" opacity="0.8" />
    </g>
  </svg>
);

export const MustardSpill = () => (
  <svg viewBox="0 0 100 100" className="w-full h-full overflow-visible">
    <g {...S}>
      <path d="M12 32 q12 -10 24 -5 q14 6 26 0 q14 -6 24 4 q8 9 -2 14 q-12 7 -24 2 q-14 8 -28 1 q-16 -5 -20 -16 z" fill="#F2B705" />
      <path d="M40 46 q-1 15 3 25 q2 8 7 5 q4 -3 1 -13 q-1 -9 3 -17" fill="#F2B705" strokeWidth="3" />
      <ellipse cx="40" cy="30" rx="8" ry="3" fill="#FFE98A" stroke="none" opacity="0.85" />
    </g>
  </svg>
);

export const MilkSpill = () => (
  <svg viewBox="0 0 100 100" className="w-full h-full overflow-visible">
    <g {...S}>
      <path d="M10 32 q10 -11 24 -5 q16 6 28 0 q14 -6 26 4 q9 8 -1 14 q-12 8 -26 3 q-14 7 -28 1 q-17 -4 -23 -17 z" fill="#FDFBF6" />
      <path d="M28 46 q-2 15 2 26 q2 9 8 6 q5 -3 2 -14 q-1 -10 4 -18" fill="#FDFBF6" strokeWidth="3" />
      <path d="M66 45 q0 12 4 21 q3 8 8 4 q4 -4 0 -13 q-2 -8 1 -14" fill="#EFE9DA" strokeWidth="3" />
      <ellipse cx="36" cy="30" rx="9" ry="3.2" fill="#FFF" stroke="none" opacity="0.9" />
    </g>
  </svg>
);